<template>
  <div class="form-container userform-container">
    <h1>利用者の登録</h1>
    <form @submit.prevent="registerUser">
      <table class="info-table">
        <tbody>

		  <!-- 地域 R.K -->
          <tr>
            <td><label class="required-label">都道府県</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="region_id" :class="{ 'input-error': errors.region }" :disabled="limited">
                <option value="" disabled>都道府県を選択してください</option>
                <option 
                  v-for="region in regions" 
                  :key="region.region_id" 
                  :value="region.region_id">
                  {{ region.region_id + ' ' + region.region_nm }}
                </option>
              </select>
              <span v-if="errors.region" class="error-message">{{ errors.region }}</span>
            </td>
          </tr>

		  <!-- R.K -->
          <tr>
            <td><label class="required-label">行政機関</label></td>
            <td><label>:</label></td>
            <td>
              <select v-model="group_id" :disabled="limited">
                <option value="" disabled>行政機関を選択してください</option>
                <option 
                  v-for="group in groups" 
                  :key="group.gyouseiId" 
                  :value="group.gyouseiId">
                  {{ group.gyouseiId + ' ' + group.gyouseiName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">利用者ID</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.userId" type="text" :disabled="limited" :class="{ 'input-error': errors.userId }" maxlength="8" @blur="validateOnBlur('userId', newUser.userId)"/>
              <span v-if="errors.userId" class="error-message">{{ errors.userId }}</span>
			</td>
          </tr>
          <tr>
            <td><label class="required-label">利用者氏名（漢字）</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.fullNameKanji" type="text" :class="{ 'input-error': errors.fullNameKanji }" maxlength="50" @blur="validateOnBlur('fullNameKanji', newUser.fullNameKanji)"/>
              <span v-if="errors.fullNameKanji" class="error-message">{{ errors.fullNameKanji }}</span>
            </td>
          </tr>
          <tr>
            <td><label>利用者氏名（カナ）</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.fullNameKana" type="text" :class="{ 'input-error': errors.fullNameKana }" maxlength="50" @blur="validateOnBlur('fullNameKana', newUser.fullNameKana)"/>
              <span v-if="errors.fullNameKana" class="error-message">{{ errors.fullNameKana }}</span>
            </td>
          </tr>

          <tr>
            <td><label class="required-label">利用者区分</label></td>
            <td><label>:</label></td>
            <td>
              <div >
                <div :class="{ 'radio-group-error': errors.userType }">
                  <label><input type="radio" value="システム管理者" v-model="newUser.userType" :disabled="disabledStates.systemAdmin" @change="validateOnBlur('userType', newUser.userType)"/> システム管理者</label>
                  <label><input type="radio" value="行政機関" v-model="newUser.userType" :disabled="disabledStates.admin" @change="handleAdminSelectionChange" /> 行政機関</label>
                  <label><input type="radio" value="その他" v-model="newUser.userType" :disabled="disabledStates.other" @change="handleOtherSelectionChange" @input="validateOnBlur('userType', newUser.userType)"/> その他</label>
                </div>
                <span v-if="errors.userType" class="error-message">{{ errors.userType }}</span>
              </div>
              <div v-if="newUser.userType === '行政機関'">
                <label><input type="radio" value="行政機関管理者" v-model="newUser.adminType" /> 行政機関管理者</label>
                <label><input type="radio" value="行政機関メンバー" v-model="newUser.adminType" /> 行政機関メンバー</label>
              </div>
              <div v-if="newUser.userType === 'その他'">
                <label><input type="radio" value="捕獲者" v-model="newUser.otherType"  :disabled="disabledStates.admin"/> 捕獲者</label>
                <label><input type="radio" value="見える化管理者" v-model="newUser.otherType" /> 見える化管理者</label>
                <label><input type="radio" value="見える化メンバー" v-model="newUser.otherType" :disabled="disabledStates.visualizationMember"/> 見える化メンバー</label>
              </div>
            </td>
          </tr>
          <tr>
            <td><label class="required-label">部署名</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.department" type="text" :class="{ 'input-error': errors.department }"  maxlength="20" @blur="validateOnBlur('department', newUser.department)"/>
              <span v-if="errors.department" class="error-message">{{ errors.department }}</span>
            </td>
          </tr>
		  <!-- R.K -->

          <tr>
            <td><label>パスワード</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.password" type="password" :class="{ 'input-error': errors.password }" maxlength="40" @blur="validateOnBlur('password', newUser.password)"/>
              <span v-if="errors.password" class="error-message">{{ errors.password }}</span>
            </td>
          </tr>
          <tr>
            <td><label>パスワード(確認用)</label></td>
            <td><label>:</label></td>
            <td>
              <input v-model="newUser.passwordConfirm" type="password" :class="{ 'input-error': errors.passwordConfirm }" maxlength="40" @blur="validateOnBlur('password', newUser.passwordConfirm)"/>
              <span v-if="errors.passwordConfirm" class="error-message">{{ errors.passwordConfirm }}</span>
            </td>
          </tr>
          <tr>
            <td><label>備考</label></td>
            <td><label>:</label></td>
            <td>
              <textarea v-model="newUser.notes" :class="{ 'input-error': errors.notes }"  maxlength="200" @blur="validateOnBlur('notes', newUser.notes)"></textarea>
              <span v-if="errors.notes" class="error-message">{{ errors.notes }}</span>
            </td>
          </tr>

          <tr>
            <td><label>所属行政機関の選択</label></td>
            <td><label>:</label></td>
            <td>
              <div class="affiliated-admin-container">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <select 
                          v-model="org_sel" 
                          multiple 
                          size="7" 
                          style="width: 200px; height: 160px;" 
                        >
                          <option 
                            v-for="(org, index) in org_left" 
                            :key="org.gyouseiId || index" 
                            :value="org.gyouseiId"
                          >
                            {{ org.gyouseiName }}
                          </option>
                        </select>
                      </td>
                      <td align="center" class="button-column-container">
                        <button 
                          type="button" 
                          @click="addAllAffiliatedOrgs" 
                        >全登録</button>
                        <button 
                          type="button" 
                          @click="addOneAffiliatedOrg" 
                        >＞＞</button>
                        <button 
                          type="button" 
                          @click="removeOneAffiliatedOrg" 
                        >＜＜</button>
                        <button 
                          type="button" 
                          @click="removeAllAffiliatedOrgs" 
                        >全解除</button>
                      </td>
                      <td>
                        <select 
                          v-model="org_sel" 
                          multiple 
                          size="7" 
                          style="width: 200px; height: 160px;" 
                          :class="{ 'input-error': errors.org_right }" 
                        >
                          <option 
                            v-for="org in org_right" 
                            :key="org.gyouseiId" 
                            :value="org.gyouseiId"
                          >
                            {{ org.gyouseiName }}
                          </option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <span 
                v-if="errors.org_right" 
                class="error-message" 
                style="text-align: right;"
              >{{ errors.org_right }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
    <div class="button-container">
      <button type="submit" class="alert" @click="registerUser" :disabled="btnoff">登録</button>
    </div>
  </div>
</template>

<script>
import '@/assets/styles/User.css';
import userValidationMixin from '@/mixins.js';
import axios from "axios";
axios.defaults.timeout = process.env.VUE_TIMEOUT||5000;

export default {
  mixins: [userValidationMixin],
  name: "UserInfo",
  data() {
    return {
	  btnoff: true,
	  limited: true,
	  group_id: '',
	  groups: [],
	  region_id: '',
      regions: [],
      section: '',
      org_right: [],
      org_left: [],
      org_sel: [],
      userTypeMapping: {
        "システム管理者": "0000",
        "行政機関": "01",
        "その他": "02",
      },
      adminTypeMapping: {
        "行政機関管理者": "00",
        "行政機関メンバー": "01",
      },
      otherTypeMapping: {
        "捕獲者": "01",
        "見える化管理者": "10",
        "見える化メンバー": "11",
      },
      newUser: {
        region: '',
        userId: '',
        password: '',
        passwordConfirm: '',
        userType: '',
        adminType: [],
        otherType: [],
        email: '',
        fullNameKanji: '',
        fullNameKana: '',
        zip: '',
        address1: '',
        address2: '',
        birthday: { type: '', year: '', month: '', day: '' },
        sex: '',
        homePhone: '',
        mobilePhone: '',
        department: '',
        notes: '',
        directAdminOrg: '',
        userType: '',
        adminType: '',
        otherType: '',
      },
      disabledStates: {
        systemAdmin: false,
        admin: false,
        other: false,
        visualizationMember: false,
      },
      isErrorMode: false, // エラーモードフラグ
      errors: {}, // エラーメッセージを格納
    };
  },
  mounted() {
    this.getRegionDetails();
	// 2026/04/06 Added by RFJ R.Komatsu
    this.section = localStorage.getItem('section');
    if (this.section == '0000') {
		this.limited = false;
    }
    this.updateDisabledStates();
  },
  watch: {
	// 2026/04/01 added by RFJ R.Komatsu
	region_id: async function() {
	  if (!this.region_id) return;
      this.newUser.region = this.region_id;

      const token = localStorage.getItem("jwtToken");
      const requestData = { regionId: this.region_id };
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/addminAgencyRegister/getRegionList`,
          requestData,
          {
            headers: {           
              Authorization: `Bearer ${token}`, // JWTトークンを送信
            },
          }
        );
        this.groups = response.data.data;
		this.org_left = this.groups;
      } catch (error) {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
	  this.group_id = '';
	  this.btnoff = true;
	  // 2026/04/06 Added by RFJ R.Komatsu
      if (this.section !== '0000') {
     	this.group_id = localStorage.getItem("directAdminAgency");
	  }
	},
	group_id: async function() {
	  if (!this.group_id) return;
      this.newUser.directAdminOrg = this.group_id;
      try {
      	const token = localStorage.getItem("jwtToken");
        const para = { id: this.group_id };
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/addminAgencyRegister/getDetail`,
          para,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      	this.newUser.userId = response.data.data.new_user;
      } catch (error) {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
	  this.btnoff = false;
	},
  },
  methods: {
    updateAdminType() {
      this.newUser.otherType = [];
    },
    updateOtherType() {
      this.newUser.adminType = [];
    },
    addOneAffiliatedOrg() {
      this.org_sel.forEach((orgId) => {
        const org = this.org_left.find((o) => o.gyouseiId === orgId);
        if (org && !this.org_right.includes(org)) {
          this.org_right.push(org);
          // 右に移動したので、左リストから削除
          this.org_left = this.org_left.filter(
            (o) => o.gyouseiId !== orgId
          );
        }
      });
      this.org_sel = [];
    },
    removeOneAffiliatedOrg() {
      this.org_sel.forEach((orgId) => {
        const org = this.org_right.find(
          (o) => o.gyouseiId === orgId
        );
        if (org && !this.org_left.includes(org)) {
          this.org_left.push(org);
          // 左に戻したので、右リストから削除
          this.org_right =
            this.org_right.filter((o) => o.gyouseiId !== orgId);
        }
      });
      this.org_sel = [];
    },
    addAllAffiliatedOrgs() {
      // 全て移動 2026/03/31 R.K バグっている・・・
      //this.org_right = [...this.org_left];
      // 左側の選択肢を右側に移動
      this.org_right = [...this.org_right, ...this.org_left];
      this.org_left = [];
    },
    removeAllAffiliatedOrgs() {
      // 右側の選択肢を左側に移動
      this.org_left = [...this.org_left, ...this.org_right];

      // 重複を排除（IDで一意なリストを作成）
      this.org_left = this.org_left.filter((org, index, self) =>
        index === self.findIndex((o) => o.gyouseiId === org.gyouseiId)
      );

      // 右側の選択肢をクリア
      this.org_right = [];
    },
    // 行政機関選択専用のチェンジメソッド
    handleAdminSelectionChange() {
      // 1. 行政機関関連の状態を更新
      this.updateAdminType();

      // 2. バリデーションを実行
      this.validateOnChange('userType', this.newUser.userType);
    },
    // その他選択専用のチェンジメソッド
    handleOtherSelectionChange() {
      // 1. その他関連の状態を更新
      this.updateOtherType();

      // 2. バリデーションを実行
      this.validateOnChange('userType', this.newUser.userType);
    },
    // ラジオボタン選択時の再バリデーションチェック
    validateOnChange(field, value) {
      const result = this.validateForm([
        {
          field,
          value,
          isRequired: true,
        },
      ]);
      this.errors[field] = result[field] || ''; // エラーがなければ解除
    },
    // フォーカスアウト時の再バリデーションチェック
    validateOnBlur(field, value) {
      if (!this.isErrorMode) return; // エラーモードがオフの場合は処理しない

      const result = this.validateForm([{ field, value, isRequired: true }]);
      this.errors[field] = result[field] || ''; // エラーがなければエラーを解除
    },
    // 所属行政機関の選択変更時のバリデーション
    validateSelectedAffiliatedOrgs(field) {
      // 配列チェックの場合は `org_right` を使用
      const result = this.validateForm([
        {
          field,
          value: this.org_right, // 正確な配列をバリデーション
          isRequired: true,
        },
      ]);

      // エラーの更新
      this.errors[field] = result[field] || ''; // エラーがなければ解除
    },
    updateDisabledStates() {
      // セクションに基づいて無効状態を設定
      if (this.section === '0000') {
        this.disabledStates = {
          systemAdmin: false,
          admin: false,
          other: false,
          visualizationMember: false,
        };
      } else if (this.section === '0100') {
        this.disabledStates = {
          systemAdmin: true,
          admin: false,
          other: false,
          visualizationMember: false,
        };
      } else if (this.section === '0210') {
        this.disabledStates = {
          systemAdmin: true,
          admin: true,
          other: false,
          visualizationMember: false,
        };
      } else {
        // デフォルト設定
        this.disabledStates = {
          systemAdmin: true,
          admin: true,
          other: true,
          visualizationMember: true,
        };
      }
    },
    loadSectionFromLocalStorage() {
      this.updateRadioButtonState(); // 状態を更新
    },
    async getRegionDetails() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");
      try {
        // リクエストボディに id を含める
        const requestData = { id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/regionSearch/getList`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          this.regions = response.data.data;
        } else {
        	alert("不明なエラーです");
        }
      } catch (error) {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
	  // 2026/04/06 Added by RFJ R.Komatsu
      if (this.section !== '0000') {
     	this.region_id = localStorage.getItem("regionId");
      }
    },
    async registerUser() {
      const fieldsToValidate = [
        { field: "region", label: "都道府県", value: this.newUser.region, isRequired: true },
        { field: "userId", label: "利用者ID", value: this.newUser.userId, isRequired: true, maxLength: 8 },
        { field: "password", label: "パスワード", value: this.newUser.password, isRequired: false, maxLength: 40 },
        { field: "passwordConfirm", label: "パスワード(確認用)", value: this.newUser.passwordConfirm, isRequired: false, maxLength: 40 },
        { field: "userType", label: "利用者区分", value: this.newUser.userType, isRequired: false },
        { field: "email", label: "メールアドレス", value: this.newUser.email, isRequired: false, maxLength: 50 },
        { field: "fullNameKanji", label: "利用者氏名（漢字）", value: this.newUser.fullNameKanji, isRequired: true, maxLength: 50 },
        { field: "fullNameKana", label: "利用者氏名（カナ）", value: this.newUser.fullNameKana, isRequired: false, maxLength: 50 },
        { field: "zip", label: "郵便番号", value: this.newUser.zip, isRequired: false, maxLength: 8 },
        { field: "address1", label: "住所１（市町村まで）", value: this.newUser.address1, isRequired: false, maxLength: 20 },
        { field: "address2", label: "住所２", value: this.newUser.address2, isRequired: false, maxLength: 20 },
        { field: "birthday.type", label: "年号", value: this.newUser.birthday.type, isRequired: false },
        { field: "birthday", label: "生年月日", value: `${this.newUser.birthday.year}-${this.newUser.birthday.month}-${this.newUser.birthday.day}`, isRequired: false },
        { field: "birthday.year", label: "年", value: this.newUser.birthday.year, isRequired: false, maxLength: 4 },
        { field: "birthday.month", label: "月", value: this.newUser.birthday.month, isRequired: false, maxLength: 2 },
        { field: "birthday.day", label: "日", value: this.newUser.birthday.day, isRequired: false, maxLength: 2 },
        { field: "sex", label: "性別", value: this.newUser.sex, isRequired: false },
        { field: "homePhone", label: "固定電話番号", value: this.newUser.homePhone, isRequired: false, maxLength: 11 },
        { field: "mobilePhone", label: "スマートフォン番号", value: this.newUser.mobilePhone, isRequired: false, maxLength: 11 },
        { field: "department", label: "所在部署名称", value: this.newUser.department, isRequired: true, maxLength: 20 },
        { field: "notes", label: "備考", value: this.newUser.notes, isRequired: false, maxLength: 200 },
        { field: "directAdminOrg", label: "直属行政機関", value: this.newUser.directAdminOrg, isRequired: true },
        { field: "org_right", label: "所属行政機関", value: this.org_right, isRequired: false }
      ]

      // エラーモードを有効化し、バリデーション実行
      this.isErrorMode = true;
      this.errors = this.validateForm(fieldsToValidate);
      
      // エラーチェック
      if (Object.values(this.errors).every((error) => !error)) {
        const token = localStorage.getItem("jwtToken");
        const userId = localStorage.getItem("userId");

        // 利用者区分の設定
        /**
         * 利用者区分について、旧スマートHOKAKUを参考にする
         * あとからDB毎見直してもよさそうだが、ひとまずはこの仕組みで考える
         * 最終的にはスマートHOKAKUに統合する必要があるので一時仕様
         * 末尾が0は管理者
         * 
         * 0000：システム管理者
         * 0100：行政機関・行政機関管理者
         * 0101：行政機関・行政機関メンバー
         * 0210：その他・見える化管理者
         * 0211：その他・見える化メンバー
         * 0201：その他・捕獲者
         */
        let userTypeValue = this.userTypeMapping[this.newUser.userType];
        if (this.newUser.userType === "行政機関") {
          userTypeValue = userTypeValue.concat(this.adminTypeMapping[this.newUser.adminType]);
        } else if (this.newUser.userType === "その他") {
          userTypeValue = userTypeValue.concat(this.otherTypeMapping[this.newUser.otherType]);
        }

        try {
          // サーバーに送信するデータ
          const requestData = {
            region_id: this.newUser.region,
            id: this.newUser.userId,
            password: this.newUser.password,
            section: userTypeValue,
            nameKana: this.newUser.fullNameKana,
            nameKanji: this.newUser.fullNameKanji,
            zip: this.newUser.zip,
            zyuusho1: this.newUser.address1,
            zyuusho2: this.newUser.address2,
            birth: this.newUser.birthday.year + '/' + this.newUser.birthday.month + '/' + this.newUser.birthday.day,
            sex: this.newUser.sex === '不明' ? '0' :
                 this.newUser.sex === '男性' ? '1' :
                 this.newUser.sex === '女性' ? '2' : null,
            tell: this.newUser.homePhone,
            mail: this.newUser.email,
            mobile: this.newUser.mobilePhone,
            departName: this.newUser.department,
            directAdminAgency: this.newUser.directAdminOrg,
            affiliationAdminAgency: this.org_right || '',
            addNote: this.newUser.notes,
            creatorId: userId,
          };

          const response = await axios.post(
            `${process.env.VUE_APP_API_BASE_URL}/api/userRegister/register`,
            requestData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          // ステータスコード200の場合（送信成功）
          if (response.status === 201) {
            // 新しいトークンがレスポンスヘッダーに含まれている場合
            const newToken = response.headers.get('Authorization');
            if (newToken) {
                localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
            }
            alert("データが正常に登録されました");

            // 必要に応じてフォームのリセットや画面遷移を実行
            //this.resetForm();          
			this.$router.go(0);
          } else if (response.status === 202) {
			alert(response.data.message);
          } else {
			alert("不明なエラーです");
		  }
        } catch (error) {
        	alert("タイムアウトです、ログインしなおしてください");
        	this.$router.push({ name: 'Login' });
        }
      } else {
        alert("入力エラーがあります");
      }
    },
    resetForm() {
      this.org_left = [];
	  this.region_id = '';
	  this.group_id = '';
      this.newUser = {
        userId: '',
        password: '',
        passwordConfirm: '',
        userType: '',
        adminType: [],
        otherType: [],
        email: '',
        fullNameKanji: '',
        fullNameKana: '',
        zip: '',
        address1: '',
        address2: '',
        birthday: { type: '', year: '', month: '', day: '' },
        sex: '',
        homePhone: '',
        mobilePhone: '',
        department: '',
        notes: '',
        directAdminOrg: '',
        userType: '',
        adminType: '',
        otherType: '',
      };
      this.org_right = [];
      this.getRegionDetails();
    },
  },
};
</script>

<style scoped>
.button-column-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.button-column-container button {
  background-color: #4caf50;
  color: white;
  border: none;
}

.button-column-container button:hover {
  background-color: #45a049; /* ホバー時に背景色を濃くする */
  transition: background-color 0.3s ease; /* なめらかな変化を追加 */
}
.usual { background-color: #17a2b8; }
.first { background-color: #28a745; }
.alert { background-color: #ff6347; }
.second { background-color: #6c757d; }
</style>
